module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAAUAA4DASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAcDBAUI/8QAJBAAAQMEAQMFAAAAAAAAAAAAAQIDEQAEBQYhEjFBBwgTYcH/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A60dyzVu+lstLUSJkRFXMZfNX4W40OEkoMjzwf2k96lZXY8fsqGsUhw2YYCiUtFUnrTKe/eAefAmJJrX9uuQ2LJ6fer2RpTN8i+cS2lTamz8XQ2RMmVGSoSY7fUkGoq1QVEQY5qS2s2i4UwYAmiig/9k="


//////////////////
// WEBPACK FOOTER
// ./static/Resized_Images/00383v.jpg
// module id = B+M2
// module chunks = 1